import { useEffect } from "react";
import { useTranscribeAndSummarizeFlow } from "../../hooks/useSummary";
import { useAlert } from "../../context/AlertContext";

/**
 * Hosts the transcribe→summarize flow for a surface that renders the interaction
 * tabs (DetailPane and the pop-out pages). Wraps useTranscribeAndSummarizeFlow
 * with the shared "alert on error, reset when done" behavior so the wiring lives
 * in one place instead of being copied into every surface.
 */
export function useHostedTranscribeAndSummarizeFlow(
  customerId: string | undefined,
  interactionId: string | undefined,
) {
  const showAlert = useAlert();
  const { phase, error, start, reset } = useTranscribeAndSummarizeFlow(
    customerId,
    interactionId,
  );

  useEffect(() => {
    if (phase === "error") {
      showAlert(error?.message ?? "Summary failed", "error");
      reset();
    } else if (phase === "completed") {
      reset();
    }
  }, [phase, error, reset, showAlert]);

  return {
    transcribeSummarizePhase: phase,
    startTranscribeAndSummarize: start,
  };
}
